import React from "react";
import styles from "./buttonLikert.module.css";
import { useLanguage } from '../../functions/setGetLanguage';

const ButtonLikert = ({ img, info, likertKey, FunctionOnClick }) => {
  const { language } = useLanguage();

  return (
    // connected buttons not black lower part
    <div className={styles.choiceItem}>
      <button className={styles.choiceButtonWrapper} onClick={() => FunctionOnClick(info)}>
        <div
            key={likertKey}
            className={`${styles.choiceButton} ${styles[`key${likertKey}`]}`}
        >
            <img
              src={img}
              alt={`choice_${likertKey}`}
              className={styles.imageButton}
            />
        </div>
        <div className={styles.paragraphButton}>
          <div className={`${styles.background_paragraphButton} ${styles[`key${likertKey}`]}`}></div>
          {info[`text${language}`]}
        </div>
      </button>
    </div>       
  );
};

export default ButtonLikert;
